import { render, staticRenderFns } from "./emp_simple.vue?vue&type=template&id=5a55d615&scoped=true&"
import script from "./emp_simple.vue?vue&type=script&lang=js&"
export * from "./emp_simple.vue?vue&type=script&lang=js&"
import style0 from "./emp_simple.vue?vue&type=style&index=0&id=5a55d615&scoped=true&lang=less&"
import style1 from "./emp_simple.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55d615",
  null
  
)

export default component.exports